import React from 'react';
import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

const StyledTitle = styled(Typography)`
  font-weight: bold;

  ${breakpointsMedia({
    xs: css`
      font-size: 24px;
    `,
    md: css`
      font-size: 30px;
    `,
    lg: css`
      font-size: 24px;
    `,
    xl: css`
      font-size: 28px;
    `,
  })}
`;

const KnowMore = () => (
  <Box
    backgroundColor="#F8F8FA"
    borderRadius="12px"
    paddingHorizontal={{ xs: '8x', lg: '8x' }}
    paddingVertical={{ xs: '8x', lg: '12x' }}
    marginHorizontal={{ xs: '8x', lg: ' 0' }}
    marginTop={{ xs: '12%' }}
    display="flex"
    flexDirection="column"
    justifyContent={{ xs: 'left', md: 'center' }}
    width="-webkit-fill-available"
    minHeight={{ xs: 'auto', lg: 'inherit' }}
  >
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={{ xs: 'center' }}
      alignItems="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <StyledTitle
          intlKey="MGM.KNOW_MORE.TITLE"
          textAlign={{ xs: 'center' }}
          marginBottom={{ xs: '2x' }}
        />
        <Link
          intlKey="MGM.KNOW_MORE.LINK"
          href="/ayuda"
          variant="action"
          color="primary"
          margin={{ xs: '0', md: '0 auto' }}
          alignSelf="center"
        />
      </Box>
    </Box>

  </Box>
);

export default KnowMore;
